(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avis-grille"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var BATCH = 12;
    var shown = BATCH;

    function updateBtn() {
      var hidden = document.querySelectorAll('#avisGrid .avis-grille__card.avis-hidden');
      var wrap = document.getElementById('avisLoadMore');
      if (!wrap) return;
      wrap.style.display = hidden.length > 0 ? 'block' : 'none';
    }

    function init() {
      var cards = document.querySelectorAll('#avisGrid .avis-grille__card');
      if (!cards.length) return;
      cards.forEach(function(card, idx) {
        if (idx >= shown) card.classList.add('avis-hidden');
      });
      updateBtn();
    }

    window.avisLoadMore = function() {
      var cards = document.querySelectorAll('#avisGrid .avis-grille__card.avis-hidden');
      var count = 0;
      cards.forEach(function(card) {
        if (count < BATCH) {
          card.classList.remove('avis-hidden');
          count++;
        }
      });
      shown += count;
      updateBtn();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avis-photos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.avis-more-btn');
    if (!btn) return;

    var gridId = btn.dataset.grid;
    var perPage = parseInt(btn.dataset.perPage);
    var shown = parseInt(btn.dataset.shown);
    var total = parseInt(btn.dataset.total);
    var grid = document.getElementById(gridId);
    if (!grid) return;

    var hidden = grid.querySelectorAll('.avis-hidden');
    var toShow = Array.prototype.slice.call(hidden, 0, perPage);
    toShow.forEach(function(el) { el.classList.remove('avis-hidden'); });

    var newShown = shown + toShow.length;
    btn.dataset.shown = newShown;

    if (newShown >= total) {
      btn.parentNode.style.display = 'none';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["badge-livraison"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var FR = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
    var EN = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var ES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

    function addDays(date, n, skipWe) {
      var d = new Date(date);
      var added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (!skipWe || (day !== 0 && day !== 6)) added++;
      }
      return d;
    }

    function fmt(d, months) {
      return d.getDate() + ' ' + months[d.getMonth()];
    }

    document.querySelectorAll('.dlv-badge').forEach(function(el) {
      var min    = parseInt(el.getAttribute('data-min'))  || 3;
      var max    = parseInt(el.getAttribute('data-max'))  || 6;
      var skipWe = el.getAttribute('data-skip-we') === 'true';
      var lang   = el.getAttribute('data-lang') || 'es';
      var months = lang === 'en' ? EN : lang === 'fr' ? FR : ES;

      var today = new Date();
      var from  = addDays(today, min, skipWe);
      var to    = addDays(today, max, skipWe);

      var fromEl = el.querySelector('.dlv-from');
      var toEl   = el.querySelector('.dlv-to');
      if (fromEl) fromEl.textContent = fmt(from, months);
      if (toEl)   toEl.textContent   = fmt(to, months);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etapes"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initEtapesSlider(section) {
    var grid = section.querySelector('.etapes__grid');
    var dotsWrap = section.querySelector('.etapes__dots');
    if (!grid) return;

    var autoplayMs = parseInt(section.getAttribute('data-autoplay')) || 3000;
    var cards = grid.querySelectorAll('.etape-card');
    var total = cards.length;
    var current = 0;
    var timer = null;
    var touchStartX = 0;
    var touchStartY = 0;
    var isDragging = false;

    function isMobile() {
      return window.innerWidth <= 768;
    }

    function getDots() {
      return dotsWrap ? dotsWrap.querySelectorAll('.etapes__dot') : [];
    }

    function updateDots() {
      getDots().forEach(function(d, i) {
        d.classList.toggle('etapes__dot--active', i === current);
      });
    }

    function goTo(index) {
      current = ((index % total) + total) % total;
      var offset = current * (100 / total);
      grid.style.transform = 'translateX(-' + (current * 100) + '%)';
      updateDots();
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayMs || !isMobile()) return;
      timer = setInterval(function() { goTo(current + 1); }, autoplayMs);
    }

    function stopAutoplay() {
      clearInterval(timer);
      timer = null;
    }

    /* Touch swipe */
    grid.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isDragging = true;
      stopAutoplay();
    }, { passive: true });

    grid.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      isDragging = false;
      var dx = touchStartX - e.changedTouches[0].clientX;
      var dy = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        goTo(dx > 0 ? current + 1 : current - 1);
      }
      startAutoplay();
    }, { passive: true });

    /* Dot clicks */
    getDots().forEach(function(dot) {
      dot.addEventListener('click', function() {
        stopAutoplay();
        goTo(parseInt(this.getAttribute('data-index')));
        startAutoplay();
      });
    });

    /* Resize */
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (!isMobile()) {
          grid.style.transform = '';
          stopAutoplay();
        } else {
          goTo(current);
          startAutoplay();
        }
      }, 150);
    });

    /* Init */
    if (isMobile()) {
      goTo(0);
      startAutoplay();
    }
  }

  function init() {
    document.querySelectorAll('.etapes[data-section-id]').forEach(initEtapesSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suivi-commande"] && !Shopify.designMode) return;
  try {
    
var TRACKING_URLS = {
  colissimo:  'https://www.laposte.fr/outils/suivre-vos-envois?code=',
  chronopost: 'https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=',
  dpd:        'https://tracking.dpd.fr/tracking?barcode=',
  ups:        'https://www.ups.com/track?tracknum=',
  dhl:        'https://www.dhl.com/fr-fr/home/tracking/tracking-parcel.html?submit=1&tracking-id=',
  geodis:     'https://www.geodis.com/fr/suivi-de-colis?trackingNumber=',
  fedex:      'https://www.fedex.com/fr-fr/tracking.html?tracknumbers=',
  gls:        'https://gls-group.com/track/FR-en-GLS/result?match='
};

function trackPackage() {
  var number = document.getElementById('trackingNumber').value.trim();
  var carrier = document.getElementById('trackingCarrier').value;
  var errorEl = document.getElementById('trackingError');

  if (!number) {
    errorEl.style.display = 'block';
    document.getElementById('trackingNumber').focus();
    return;
  }

  errorEl.style.display = 'none';
  var url = TRACKING_URLS[carrier] + encodeURIComponent(number);
  window.open(url, '_blank', 'noopener');
}

document.getElementById('trackingNumber').addEventListener('keydown', function(e) {
  if (e.key === 'Enter') trackPackage();
});

document.getElementById('trackingNumber').addEventListener('input', function() {
  document.getElementById('trackingError').style.display = 'none';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var carousel = document.getElementById('avisCarousel');
    if (!carousel) return;

    var timer;
    var delay = 3000;

    function getCardWidth() {
      var card = carousel.querySelector('.avis-card');
      return card ? card.offsetWidth + 20 : 300;
    }

    function slide(dir) {
      var atEnd = carousel.scrollLeft + carousel.offsetWidth >= carousel.scrollWidth - 4;
      if (dir > 0 && atEnd) {
        carousel.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        carousel.scrollBy({ left: dir * getCardWidth(), behavior: 'smooth' });
      }
    }

    function startAuto() {
      clearInterval(timer);
      timer = setInterval(function() { slide(1); }, delay);
    }

    function stopAuto() { clearInterval(timer); }

    window.scrollAvis = function(dir) {
      slide(dir);
      startAuto();
    };

    startAuto();

    carousel.addEventListener('mouseenter', stopAuto);
    carousel.addEventListener('mouseleave', startAuto);
    carousel.addEventListener('touchstart', stopAuto, { passive: true });
    carousel.addEventListener('touchend', startAuto, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
